export default "__VITE_ASSET__CYsZtOOb__"